import { OnlineCheckinStatusType, ReservationDetails } from '../../types';

export const getCheckinStatus = (reservation: ReservationDetails['reservation']) => {
  const { onlineCheckin } = reservation;

  if (onlineCheckin?.status === OnlineCheckinStatusType.complete) {
    return 'Complete';
  } else if (onlineCheckin?.status === OnlineCheckinStatusType.disabled) {
    return 'Disabled';
  }

  return 'Incomplete';
};
